// extracted by mini-css-extract-plugin
export default {"icon":"wRyoU","wrap":"qPFK4","button":"QYGS1","no-vertical-margin":"qIqba"};